import get from 'lodash/get'
import { ReduxState } from 'app-types'

export const getMaxDocuments = (state: ReduxState): number => get(state, 'pop.maxDocuments', 0)
